<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      :key="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col>
        <b-card no-body class>
          <b-tabs card content-class="mt-3">
            <b-tab title="Paiements">
              <b-card-title title-tag="h6">
                Paiements
                <span v-if="resultsInfo">({{ resultsInfo }} résultats)</span>
              </b-card-title>
              <div class="d-flex justify-content-start align-items-center">
                <b-button
                  icon
                  :to="{ path: '/invoices-commissions' }"
                  size="sm"
                  title="Factures commissions"
                  ><i class="fad fa-file-invoice"></i>
                </b-button>
                <label class="mx-3 align-self-center">Rechercher :</label>
                <mh-input
                  append="🔍"
                  field="search"
                  :table="searchTable"
                  autofocus
                  :autocomplete="{
                    field:
                      'debiteur.(nom prenom) || debiteur.nom_soc || creancier.(nom prenom) || creancier.nom_soc',
                  }"
                  @enter="submitSearch()"
                ></mh-input>
                <label class="mx-3 align-self-center">Status :</label>
                <mh-input
                  field="status"
                  :table="searchTable"
                  @change="submitSearch()"
                ></mh-input>
              </div>
              <b-row v-if="$options.payments.length > 0" class="mt-3">
                <b-col lg="12">
                  <h5>
                    <b-badge
                      >Total chez nous :
                      {{ Number(total.societe).toLocaleString() }} €</b-badge
                    >
                    <b-badge class="float-right"
                      >Total chez les créanciers :
                      {{ Number(total.creancier).toLocaleString() }} €</b-badge
                    >
                  </h5>
                  <b-table-simple hover small responsive="">
                    <b-thead>
                      <b-tr>
                        <b-th>N° de mandat</b-th>
                        <b-th>Débiteur</b-th>
                        <b-th style="max-width: 200px">Créancier</b-th>
                        <b-th>Type</b-th>
                        <b-th>Date</b-th>
                        <b-th>Date d'encodage</b-th>
                        <b-th class="sort-col" @click="sortChange()"
                          >Chez nous
                          <b-icon-arrow-down-circle-fill
                            v-if="sortDesc"
                            class="ml-2"
                          ></b-icon-arrow-down-circle-fill>
                          <b-icon-arrow-up-circle-fill
                            v-else
                            class="ml-2"
                          ></b-icon-arrow-up-circle-fill>
                        </b-th>
                        <b-th>Chez le créancier</b-th>
                        <b-th>Compte crédité</b-th>
                        <b-th>Compte débité</b-th>
                        <b-th>Extrait</b-th>
                        <b-th>Réception</b-th>
                        <b-th>Négociateur</b-th>
                        <b-th>Actions</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <template v-for="(payment, i) in $options.payments">
                        <b-tr
                          v-if="
                            i == 0 ||
                            payment.date != $options.payments[i - 1].date
                          "
                          :key="i"
                        >
                          <b-td colspan="14" class="bg-dark"
                            ><h6 class="text-light pt-2">
                              {{ toDate(payment.date) }}
                            </h6></b-td
                          >
                        </b-tr>
                        <b-tr
                          v-if="
                            i == 0 ||
                            payment.compte_societe !=
                              $options.payments[i - 1].compte_societe
                          "
                          :key="'soc-' + i"
                        >
                          <b-td colspan="14" class="bg-info"
                            ><span class="text-light pt-2">{{
                              payment.compte_societe
                            }}</span></b-td
                          >
                        </b-tr>
                        <b-tr :key="'router-' + i">
                          <b-td
                            ><router-link
                              :to="{
                                name: 'warrantEdit',
                                params: { id: payment.mandatID },
                              }"
                              >{{ payment.mandatID }}</router-link
                            ></b-td
                          >
                          <b-td
                            ><b-link
                              :to="{
                                name: 'debtorView',
                                params: { id: payment.debiteurID },
                              }"
                            >
                              <span
                                v-html="company(payment.debiteur)"
                              ></span> </b-link
                          ></b-td>
                          <b-td style="max-width: 200px">
                            <div class="w-100 text-truncate">
                              <b-link
                                :to="{
                                  name: 'creditorView',
                                  params: { id: payment.creancierID },
                                }"
                              >
                                <span
                                  v-html="company(payment.creancier)"
                                ></span>
                              </b-link>
                            </div>
                          </b-td>
                          <b-td>
                            {{ payment.type }}
                          </b-td>
                          <b-td>
                            {{ toDate(payment.date) }}
                          </b-td>
                          <b-td>
                            {{ toDate(payment.date_encodage) }}
                          </b-td>
                          <b-td class="text-right font-weight-bold">
                            <span v-if="payment.reception == 'societe'"
                              >{{ payment.montant }} €</span
                            >
                          </b-td>
                          <b-td class="text-right font-weight-bold">
                            <span v-if="payment.reception == 'creancier'"
                              >{{ payment.montant }} €</span
                            >
                          </b-td>
                          <b-td>{{ payment.compte_societe }}</b-td>
                          <b-td>{{ payment.compte_debiteur }}</b-td>
                          <b-td>{{ payment.numero_extrait }}</b-td>
                          <b-td>{{ payment.reception }}</b-td>
                          <b-td>{{ payment.negotiateur }}</b-td>
                          <b-td>
                            <template v-if="payment.invoiced != 'Yes'">
                              <b-button
                                variant="success"
                                @click="editPayment(payment)"
                                title="Éditer"
                                size="sm"
                                class="btn-xs"
                                icon
                              >
                                <b-icon-pencil-square></b-icon-pencil-square>
                              </b-button>
                              <b-button
                                variant="danger"
                                v-if="$store.getters.isSuperAdmin"
                                @click="deletePayment(payment)"
                                title="Supprimer"
                                size="sm"
                                class="btn-xs ml-2"
                                icon
                              >
                                <b-icon-x-circle-fill></b-icon-x-circle-fill>
                              </b-button>
                            </template>
                            <span v-else><i>Facturé</i></span>
                          </b-td>
                        </b-tr>
                      </template>
                    </b-tbody>
                  </b-table-simple>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab lazy title="Flux financier">
              
              <FinancialFlow></FinancialFlow>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-modifier-paiement"
      title="Modifier un paiement"
      hide-footer
    >
      <WarrantPayment
        @change="this.submitSearch()"
        @close="$bvModal.hide('modal-modifier-paiement')"
        :payment_id="payment_id"
        :warrant_id="warrant_id"
      ></WarrantPayment>
    </b-modal>
  </div>
</template>

<script>
import MhInput from "@/components/MhInput";
import payments from "@/services/payments.js";
import DateTime from "@/services/DateTime.js";
import String from "@/services/String.js";
import WarrantPayment from "@/components/WarrantPayment";
import FinancialFlow from "@/components/FinancialFlow";
export default {
  components: {
    MhInput,
    WarrantPayment,
    FinancialFlow
  },
  name: "payments",
  payments: [],
  data() {
    return {
      searchTable: {
        status: {
          label: "",
          type: "enum",
          value: "not-invoiced",
          options: [
            {
              value: "not-invoiced",
              text: "Non facturés",
            },
            {
              value: "invoiced",
              text: "Facturés",
            },
            {
              value: "all",
              text: "Tous les paiements",
            },
          ],
        },
        base: {
          label: "",
          type: "enum",
          value: "encodage",
          options: [
            {
              value: "encodage",
              text: "Date d'encodage",
            },
            {
              value: "paiement",
              text: "Date de paiement",
            },
          ],
        },
        search: {
          label: "",
          type: "varchar",
          value: "",
        },
      },
      defaultFilter: true,
      debug: false,
      info: {},
      search: this.$route.params.search || "",
      facets: [],
      filters: [],
      total: {},
      page: 1,
      payment_id: null,
      warrant_id: null,
      pagination: {},
      resultsInfo: "",
      loaded: true,
      busy: false,
      sortBy: "montant",
      sortDesc: true,
      actions: [
        {
          label: "Éditer",
          to: "paymentView",
        },
      ],
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Paiements",
          active: true,
        },
      ],
      fields: [
        {
          key: "mandatID",
          label: "N° de mandat",
          sortable: true,
          class: "text-right",
          thStyle: { width: "5%" },
        },
        {
          key: "debiteur",
          label: "Débiteur",
          sortable: true,
          thStyle: { width: "10%" },
        },
        {
          key: "creancier",
          label: "Créancier",
          sortable: true,
          thStyle: { width: "10%" },
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
        },
        { key: "date", label: "Date", sortable: true, class: "text-center" },
        {
          key: "date_encodage",
          label: "Date d'encodage",
          class: "text-center",
          sortable: true,
        },
        {
          key: "cheznous",
          label: "Chez nous",
          sortable: true,
          class: "text-right font-weight-bold",
        },
        {
          key: "chezvous",
          label: "Chez le créancier",
          sortable: true,
          class: "text-right font-weight-bold",
        },
        {
          key: "compte_societe",
          label: "Compte crédité",
          sortable: true,
        },
        {
          key: "compte_debiteur",
          label: "Compte débité",
          sortable: true,
        },
        {
          key: "numero_extrait",
          label: "Extrait",
          sortable: false,
          class: "text-truncate",
        },
        {
          key: "reception",
          label: "Réception",
          sortable: true,
          formatter: (val) => {
            if (val == "creancier") {
              return "Créancier";
            }
            return "Société";
          },
        },
        {
          key: "negotiateur",
          label: "Négotiateur",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          thStyle: "width:100px",
        },
      ],
    };
  },
  created() {
    this.search = this.$route.params.search || "";
    this.scroll();
    this.loaded = false;
    this.submitSearch();
  },

  methods: {
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight + 300 >
          document.documentElement.offsetHeight;
        if (
          bottomOfWindow &&
          this.pagination.numberOfPages > this.page &&
          !this.busy
        ) {
          this.page++;
          this.continueSearch();
        }
      };
    },
    editPayment(item) {
      this.warrant_id = item.mandatID;
      this.payment_id = item.ID;
      this.$bvModal.show("modal-modifier-paiement");
    },
    fullName(a, b) {
      return String.fullName(a, b);
    },
    ucfirst(a) {
      return String.ucfirst(a);
    },
    company(a) {
      return String.company(a);
    },
    toDate(d) {
      return DateTime.shortDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
    reinit() {
      this.page = 1;
      this.filters = [];
      return true;
    },
    sortChange() {
      this.sortDesc = !this.sortDesc;
      this.submitSearch();
    },
    changeSort(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.submitSearch();
    },
    changePage(page) {
      this.page = page;
      this.submitSearch(false);
    },
    removeFilter(index) {
      this.filters.splice(index, 1);
      this.submitSearch();
    },
    narrow(object) {
      this.filters.push(object);
      this.submitSearch();
    },

    deletePayment(id) {
      payments.delete(id).then((response) => {
        this.$bvToast.toast(response.data.message, {
          title: `Recuperator`,
          toaster: "b-toaster-top-right",
          variant: "success",
          autoHideDelay: 2000,
          solid: false,
        });
        this.submitSearch();
      });
    },
    continueSearch() {
      this.busy = true;
      payments
        .search_old(
          this.searchTable.search.value,
          this.searchTable.status.value,
          this.searchTable.base.value,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc
        )
        .then((response) => {
          this.$options.payments = this.$options.payments.concat(
            response.data.results.records
          );
          this.pagination = response.data.results.pagination;
          this.busy = false;
        })
        .catch(() => {
          this.busy = false;
        });
    },
    submitSearch() {
      this.busy = true;
      this.page = 1;
      payments
        .search_old(
          this.searchTable.search.value,
          this.searchTable.status.value,
          this.searchTable.base.value,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc
        )
        .then((response) => {
          this.$options.payments = response.data.results.records;
          this.pagination = response.data.results.pagination;
          this.resultsInfo = this.pagination.totalRecords;
          this.total = response.data.total;
          this.loaded = true;
          this.busy = false;
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.sort-col {
  &:hover {
    cursor: pointer;
  }
}
</style>